<div *ngIf="showSelectFileDialog">
  <input
    #hiddenfileinput
    type="file"
    accept="{{ attribAccpet }}"
    hidden
    multiple
    (change)="onFilesSelected($event)"
    [disabled]="disabled"
  />
  <app-icon-text-button
    text="{{ textUploadButton }}"
    imagePath="../../../../assets/icons/add-arquivo.svg"
    (click)="hiddenfileinput.click()"
  >
  </app-icon-text-button>
</div>

<div class="container">
  <div *ngFor="let fileData of downloadFilesControl; index as i">
    <div class="files-list">
      <div *ngIf="fileExtension(fileData.name!) !== 'PDF'; else pdfFile">
        <div *ngIf="imgURL[i] === null; else previewImage">
          <div class="download-image" *ngIf="isImage(fileData.name!)">
            <img
              class="download-image-crop"
              src="../../../../assets/icons/file_download.png"
            />
            <app-download-button
              class="download-image-download"
              *ngIf="!fileData.isActive"
              (processChange)="onDownloadClick(fileData, i, $event)"
            ></app-download-button>
          </div>
        </div>
        <ng-template #previewImage>
          <img
            class="download-image-crop"
            (click)="onDownloadClick(fileData, i, true)"
            [src]="imgURL[i]"
          /><br />
        </ng-template>
      </div>
      <ng-template #pdfFile>
        <div class="download-image">
          <img class="download-image-crop-pdf" [src]="pdfIcon" />
          <app-download-button
            class="download-image-download"
            *ngIf="!fileData.isActive"
            (processChange)="onDownloadClick(fileData, i, $event)"
          ></app-download-button>
        </div>
      </ng-template>
      <div class="download-image-about">
        <div>
          <span class="download-image-title">{{ fileData.name! }}</span
          ><br />
          <span
            *ngIf="fileInfoExists(fileData.name!)"
            class="download-image-subtitle"
          >
            {{ fileExtension(fileData.name!) }} |
            {{ fileSize(fileData.name!) }}
          </span>
        </div>

        <div class="news-selected-button"   [ngClass]="{'disabled': disabled}">
          <img
            class="news-selected-button-img"
            (click)="onRemoveFileClick(fileData.name!, i)"
            src="../../../../assets/icons/lixeira.svg"
          />
        </div>
      </div>
    </div>
  </div>
</div>
